
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'PageTitle',
    props: {
      classContainer: {
        type: String,
        default: 'container-page big container-page--no-indentation',
      },
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: '',
      },
      subtitleNumber: {
        type: [Number, String],
        default: '',
      },
      classTitleBlock: {
        type: String,
        default: '',
      },
      classListInfo: {
        type: String,
        default: '',
      },
      miniIndentation: {
        type: Boolean,
        default: false,
      },
      // Для отступа у заголовка в версии 748 и меньше, чтобы был 24px
      dense: {
        type: Boolean,
        default: false,
      },
    },
  });
